import { Tag } from '@cimpress/react-components';
import { NavLink } from 'react-router-dom';
import styles from '../css/pages.module.scss';
import { singularize, toTitleCase } from '../utilities/common';

export interface DetailViewProps {
  detailName: string;
  detailList: Detail[];
}

export interface Detail {
  key: string;
  value: string;
  style?: string;
  children?: Detail[];
  link?: string;
}

export interface AttributeDetailProps {
  detail: Detail;
  detailName?: string;
  index?: number;
}

export interface DetailViewProps {
  detailName: string;
  detailList: Detail[];
  length?: number;
}

const AttributeDetail = ({
  detail,
  detailName,
  index,
}: AttributeDetailProps) => {
  const { key, value, style, children, link } = detail;
  const testId =
    detailName !== undefined && index !== undefined
      ? `detail-${detailName}-${index}`
      : 'detail';

  if (
    (value.toLowerCase() === 'object' || value.toLowerCase() === 'array') &&
    children &&
    children.length > 0
  ) {
    return (
      <div
        data-cy="detail"
        data-testid={testId}
        className={styles.entityTypeDataValues}
      >
        <b>{toTitleCase(key)}</b>
        <details
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <summary style={{ alignSelf: 'flex-end' }}>
            <Tag value={toTitleCase(value)} className={style} />
          </summary>
          <div className={styles.nestedAttributesContainer}>
            {children.map((childDetail, childIndex) => (
              <AttributeDetail key={childIndex} detail={childDetail} />
            ))}
          </div>
        </details>
      </div>
    );
  }

  // Render as a link if link property is provided
  if (link) {
    return (
      <div
        data-cy="detail"
        data-testid={testId}
        className={styles.entityTypeDataValues}
      >
        <NavLink to={link} className={styles.relationshipLink}>
          {toTitleCase(key)}
        </NavLink>
        {value && <Tag value={toTitleCase(value)} className={style} />}
      </div>
    );
  }

  return (
    <div
      data-cy="detail"
      data-testid={testId}
      className={styles.entityTypeDataValues}
    >
      <b>{toTitleCase(key)}</b>
      {value && <Tag value={toTitleCase(value)} className={style} />}
    </div>
  );
};

const DetailView = (props: DetailViewProps) => {
  return (
    <div className={styles.entityTypePaneContainer} data-testid="detail-view">
      <CountDisplay length={props.detailList.length} name={props.detailName} />
      {props.detailList.map((detail, index) => (
        <AttributeDetail
          key={`attribute:${detail.key}-${index}`}
          detail={detail}
          detailName={props.detailName}
          index={index}
        />
      ))}
    </div>
  );
};

interface CountDisplayProps {
  length: number;
  name: string;
}

const CountDisplay = ({ length, name }: CountDisplayProps) => {
  return (
    <p>
      Total {length} {singularize(name, length)}
    </p>
  );
};

export default DetailView;
